import { IDatasourceOptions } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { Course } from './../builders/course_builder';

interface ITransferCoursesDatasourceModel {
  hasFirstCourseBeenSelected: boolean;
}

export interface ITransferCoursesDatasource extends IDatasource<Course> {
  model: ITransferCoursesDatasourceModel;
}

angular
  .module('capability-ng-transfer')
  .factory('ngTransferCoursesDatasource', function(
    ngCourseBuilder: typeof Course,
    Datasource: IDatasourceConstructor<Course>
  ): ITransferCoursesDatasource {
    const coursesDataSource: ITransferCoursesDatasource = new Datasource<Course, ITransferCoursesDatasourceModel>({
      builderType: ngCourseBuilder
    }).includeModel({
      hasFirstCourseBeenSelected: false
    });

    return coursesDataSource;
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/datasources/transfer_courses_datasource.ts